import {Component, input, output} from '@angular/core';
import {CompanySummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-company-grid',
  imports: [
    TableModule,
    TranslatePipe,
    ElciaButton
  ],
  templateUrl: './company-grid.html',
  styleUrl: './company-grid.scss'
})
export class CompanyGrid {
  companies = input.required<CompanySummary[]>();
  isLoading = input.required<boolean>();
  onDelete = output<CompanySummary>();
  companySelected = output<CompanySummary>();

  onRowSelect(company: CompanySummary): void {
    this.companySelected.emit(company);
  }

  delete(event: Event, company: CompanySummary): void {
    event.stopPropagation();
    this.onDelete.emit(company);
  }
}
